import { render, staticRenderFns } from "./CourseProgress.vue?vue&type=template&id=4f687970&"
import script from "./CourseProgress.vue?vue&type=script&setup=true&lang=ts&"
export * from "./CourseProgress.vue?vue&type=script&setup=true&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports